import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    educationLevels: [],
    educationLevelsCount: 0,
    educationLevel: {},
    educationLevelSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getEducationLevels(state) {
      return state.educationLevels
    },
    getEducationLevelsCount(state) {
      return state.educationLevelsCount
    },
    getEducationLevel(state) {
      return state.educationLevel
    },
    getEducationLevelSaveStatus(state) {
      return state.educationLevelSave
    },
  },
  mutations: {
    EDUCATION_LEVELS_LIST(state, data) {
      state.educationLevels = data
    },
    EDUCATION_LEVEL_VIEW(state, data) {
      state.educationLevel = data
    },
    EDUCATION_LEVELS_COUNT(state, data) {
      state.educationLevelsCount = data
    },
    EDUCATION_LEVEL_SAVE(state, data) {
      state.educationLevelSave = data
    },
  },
  actions: {
    educationLevelsList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/hrDefines/education_levels', data)
        .then(response => {
          commit('EDUCATION_LEVELS_LIST', response.data.data)
          commit('EDUCATION_LEVELS_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    educationLevelView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'education_levels.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/hrDefines/education_levels', data)
        .then(response => {
          commit('EDUCATION_LEVEL_VIEW', response.data.data)
        })
        .catch(error => console.error(error))
    },
    educationLevelSave({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post('/hrDefines/education_levels/saveData', data)
        .then(response => {
          commit('EDUCATION_LEVEL_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
